import store from '@/store'

/**
 * Storage backend from tenant feature flags (featureFlags.PAGE_STORAGE_BACKEND).
 * - firestore: legacy Firestore recipes (currentPage.data.recipes)
 * - google-cloud-storage: new Cloud Storage (data.json, index.html, styles.css)
 * Default: firestore when flag is missing (safe for progressive migration).
 */
export default function getStorageManagerConfig() {
  const featureFlags = store.getters['tenant/getFeatureFlags'] || {}
  const type = featureFlags.PAGE_STORAGE_BACKEND || 'firestore'

  return {
    storageManager: {
      type,
      autosave: false,
      autoload: true,
      id: 'novti-recipe-', // Prefix identifier that will be used on parameters
    },
  }
}
